import { render, staticRenderFns } from "./VerifyDeleteOverdue.vue?vue&type=template&id=127607b8"
import script from "./VerifyDeleteOverdue.vue?vue&type=script&lang=js"
export * from "./VerifyDeleteOverdue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports